import classes from './CycleInfo.module.css';

function CycleInfo(props) {
    // adjust the size of the arrow based on the length of the character input
    let arr_coord = `M 1 10 ${props.width - 7} 10`;

    let sample_parallel_min = ''
    let sample_parallel_max = '';
    let cycle_time_min = '';
    let cycle_time_max = '';
    let cycle_time_unit = '';


    if(props.cycle_info){
        sample_parallel_min = props.cycle_info.runparallel_min ;
        sample_parallel_max = props.cycle_info.runparallel_max ;
        cycle_time_min = props.cycle_info.cycletime_min;
        cycle_time_max = props.cycle_info.cycletime_max;
        cycle_time_unit = props.cycle_info.cycletime_unit;
    }

    if(props){
        return(
            <>
                <div style={{position:'relative', display: 'flex', width:'fit-content', height:'fit-content', marginBottom:'10px', margin:'0px', padding:'0px'}} >
                    <div style={{position:'relative', width:'30px', height:'16px', background:'var(--aixelo-gray-light)', border:'1px solid var(--aixelo-gray-dark)' }}></div>
                    <div style={{position:'relative', width:'30px', marginTop:'5px', marginLeft:'-28px', height:'16px', background:'var(--aixelo-gray-light)', border:'1px solid var(--aixelo-gray-dark)' }}></div>
                    <div style={{position:'relative', width:'30px', marginTop:'10px', marginLeft:'-28px', height:'16px', background:'var(--aixelo-gray-light)', border:'1px solid var(--aixelo-gray-dark)' }}></div>
                    <div style={{position:'relative', marginLeft:'10px', marginRight:'5px', height:'fit-content', top:'7px', margins:'0px', fontSize:'14px'}}>samples in parallel: </div>
                    <input id={'runparallel_min_'+props.cycle_id} placeholder='min' type='number'  pattern='[0-9]+' autoComplete="false" value={sample_parallel_min} onChange={props.handleInputData} className={classes.input_box} style={{top:'5px'}} />
                    <div style={{position:'relative', top:'6px'}}> - </div>
                    <input id={'runparallel_max_'+props.cycle_id} placeholder='max' type='number' step="1" autoComplete="false" value={sample_parallel_max} onChange={props.handleInputData} className={classes.input_box} style={{top:'5px'}}/>
                </div>
                <div style={{position:'relative', left: '50px', marginTop:'10px', padding:'0px', display:'flex', justifyContent:'center', alignItems:'center', width:'fit-content', height:'fit-content'}}>
                    <div style={{position:'relative', width:'fit-content', height:'fit-content', fontSize:'14px'}}>
                    estimated cycle time:</div>
                    <input id={'cycletime_min_'+props.cycle_id} placeholder='min' type='number' autoComplete="false" value={cycle_time_min !== null ? cycle_time_min : ''} onChange={props.handleInputData} className={classes.input_box} />
                    -
                    <input id={'cycletime_max_'+props.cycle_id} placeholder='max' type='number' autoComplete="false" value={cycle_time_max} onChange={props.handleInputData} className={classes.input_box} />
                    <input id={'cycletime_unit_'+props.cycle_id} placeholder='unit' autoComplete="false" value={cycle_time_unit} onChange={props.handleInputData} className={classes.input_box} style={{width: '55px', marginRight:'0px'}} />
                </div>

                <div style={{position:'relative', display: 'flex', left:'0px', top:'0px', width:props.width, height:'20px'}}>
                    <svg style={{position:'relative', left:'0px', width: '100%', height:'20px'}}>
                            <defs>
                            <marker
                            id="triangleCycleLeft"
                            viewBox="0 0 10 10"
                            refX="1"
                            refY="5"
                            markerUnits="strokeWidth"
                            markerWidth="4"
                            markerHeight="4"
                            orient="auto">
                            <path d="M 0 5 L 10 10 L 10 0 z" fill="var(--aixelo-gray-dark)" />
                            </marker>

                            <marker
                            id="triangleCycleRight"
                            viewBox="0 0 10 10"
                            refX="1"
                            refY="5"
                            markerUnits="strokeWidth"
                            markerWidth="4"
                            markerHeight="4"
                            orient="auto">
                            <path d="M 0 0 L 10 5 L 0 10 z" fill="var(--aixelo-gray-dark)" />
                            </marker>

                        </defs>
                        <path   d={arr_coord} stroke="var(--aixelo-gray-dark)" strokeWidth="1.5" markerEnd="url(#triangleCycleRight)" markerStart="url(#triangleCycleLeft)"/>
                    </svg>
                </div>
            </>);
    }
}

export default CycleInfo;